export const business = {
  name: 'Oh My Tacos',
  tagline: 'Auténtica comida mexicana — street tacos, burritos & quesadillas made fresh at the window.',
  phoneDisplay: '(725) 715-5070',
  phoneHref: 'tel:7257155070',
  todayStop: 'Las Vegas, NV',
  todayHours: '11am – 8pm',
}

export const schedule = [
  { day: 'Tue – Thu', hours: '11am – 8pm' },
  { day: 'Fri – Sat', hours: '11am – 10pm' },
  { day: 'Sunday', hours: '12pm – 6pm' },
  { day: 'Monday', hours: 'Closed' },
]

export const notices = [
  'Call ahead and your order will be ready at the window.',
  'Catering & private events available — just give us a call.',
  '*Prices may change without notice due to changing food costs*',
]
